import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminOrganizationDetailResponse } from '@utils/types/admin';

type UseGetAdminOrganizationOptions = Omit<
  UseQueryOptions<AdminOrganizationDetailResponse, AxiosError<BaseError>>,
  'queryKey' | 'queryFn'
>;

/**
 * Hook to fetch a single on-prem organization detail
 *
 * GET /api/admin/on-prem/organizations/{id}
 *
 * Returns organization details with settings
 */
export const useGetAdminOrganization = (
  organizationId: string | number,
  options?: UseGetAdminOrganizationOptions
) => {
  const fetchOrganization = async () => {
    const url = `api/admin/on-prem/organizations/${organizationId}`;
    const response = await Axios.get<AdminOrganizationDetailResponse>(url);
    return response.data;
  };

  return useQuery<AdminOrganizationDetailResponse, AxiosError<BaseError>>(
    ['adminOrganization', organizationId],
    fetchOrganization,
    {
      useErrorBoundary: false,
      enabled: !!organizationId,
      ...options
    }
  );
};
